import experimentation from "@pcln/experimentation";
const useSeti = ({ testName, shouldFireImpression })=>{
    if (shouldFireImpression) experimentation.fireImpression(testName);
    return experimentation.isVariant(testName);
};
const getSetiState = (testName)=>{
    if ('undefined' != typeof window && 'function' == typeof experimentation?.getTestState) return experimentation.getTestState(testName);
    return 'DEFAULT';
};
export { getSetiState, useSeti };
